import React, { useState } from 'react'
import emailjs from '@emailjs/browser';
import '../Landingpage/About.css'
import { Typography } from '@mui/material';
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa6";
import { FaSquareXTwitter } from "react-icons/fa6";
import { SiGooglescholar } from "react-icons/si";

const Socials = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    // console.log(process.env.REACT_APP_PUBLIC_KEY)
    // console.log(process.env.REACT_APP_SERVICE_ID)

    const handleSubmit = (e) => {
        e.preventDefault();

        // Your EmailJS service ID, template ID, and Public Key
        const serviceId =
            "service_oscvg1h"
        // process.env.REACT_APP_SERVICE_ID;
        const templateId =
            "template_rl3gqxa"
        //process.env.REACT_APP_TEMPLATE_ID;
        const publicKey =
            "lI59_AGiB0wlJfPTD"
        //process.env.REACT_APP_PUBLIC_KEY;

        // Create a new object that contains dynamic template params
        const templateParams = {
            from_name: name,
            from_email: email,
            to_name: 'Sanika',
            message: message,
        };

        // Send the email using EmailJS
        emailjs.send(serviceId, templateId, templateParams, publicKey)
            .then((response) => {
                console.log('Email sent successfully!', response);
                setName('');
                setEmail('');
                setMessage('');
                alert("Thank you for reaching out! i will get back to you within 1-2 business days")
            })
            .catch((error) => {
                console.error('Error sending email:', error);
            });
    }

    return (
        <div className='divv'>
            <section className='panell'>
                <Typography style={{ fontFamily: "Lilita One", fontSize: "1.7rem", paddingBottom: "8px", fontWeight: "100", lineHeight: "25px" }}>Drop me an email to collaborate or just say hi!</Typography>
                <form onSubmit={handleSubmit} className='emailForm'>
                    <input
                        type="text"
                        placeholder="Your Name:"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className='boxes'
                        style={{ width: "200px", height: "25px", borderRadius: "5px", fontFamily: "Signika", fontSize: "1.3rem" }}
                    />
                    <input
                        type="email"
                        placeholder="Your Email:"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className='boxes'
                        style={{ width: "200px", height: "25px", borderRadius: "5px", fontFamily: "Signika", fontSize: "1.3rem" }}
                    />
                    <textarea
                        cols="30"
                        rows="10"
                        placeholder="Your Message:"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        className='boxes'
                        style={{ borderRadius: "10px", fontFamily: "Signika", fontSize: "1.3rem" }}
                    >
                    </textarea>
                    <button type="submit" className='boxes' style={{ backgroundColor: "#098561", fontFamily: "Signika", fontSize: "1.3rem", borderRadius: "10px", fontWeight: "650", color: "white" }}>Send Email</button>
                </form>
                <Typography align="center"
                    style={{ fontSize: "18px", fontFamily: "Signika", fontWeight: "650" }}

                >My email-id: sanikaardekar@gmail.com</Typography>
            </section>
            <Typography style={{ fontFamily: "Lilita One", fontSize: "1.7rem", paddingBottom: "8px", marginTop: "15px", textAlign: "center", fontWeight: "100" }}>
                <span style={{ backgroundColor: "#098561", padding: "4px" }}>My Socials</span> </Typography>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", alignContent: "center", marginBottom: "5px" }}>

                <a href="https://www.linkedin.com/in/sanikaardekar/">
                    <FaLinkedin style={{ fontSize: "2.5rem", color: "#0A66C2" }} />
                </a>
                <a href="https://github.com/sanikaardekar">
                    <FaGithub style={{ fontSize: "2.5rem", color: "white" }} />
                </a>
                <a href="https://scholar.google.com/citations?user=gvzJIM4AAAAJ&hl=en">
                    < SiGooglescholar style={{ fontSize: "2.5rem", color: "#4285F4" }} />
                </a>
                <a href="https://twitter.com/saradinex">
                    <FaSquareXTwitter style={{ fontSize: "2.5rem", color: "white" }} />
                </a>
            </div>
            <Typography textAlign="center">Made with ❤️ by Sanika</Typography>
        </div>
    )
}

export default Socials